export function getAll() {
  return [
    {
      value: 0,
      name: "Normal",
      text: "清單模式",
    },
    {
      value: 1,
      name: "Scanner",
      text: "掃描模式",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
